class MiddlewareTable {
  constructor(data) {
    this.clientName = data?.profile?.client_name;
    this.platform = data?.profile.client_type;
    this.ref_id = data?.profile?.ref_id;
    this.active_status = data?.profile?.is_active;
    this.order_sync_status =
      data?.profile?.client_type === 'Shopify' && data?.profile?.is_active === 'true'
        ? true
        : data?.profile_individual?.orders_sync_status ?? 'NA';
    this.profileIndividual = {
      api_error: data?.profile_individual?.error_message ?? 'NA',
      order_sync_status:
        data?.profile?.client_type === 'Shopify' && data?.profile?.is_active === 'true'
          ? true
          : data?.profile_individual?.orders_sync_status ?? 'NA',
      last_order_fetch_time: data?.profile_individual?.handler_timer ?? 'NA',
    };
    this.parentSystem = data?.profile?.parent_system;
    const orderSyncFlow = data?.sync_flows?.find(f => f.flow_name === 'order_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.order_sync_flow = orderSyncFlow;
    this.order_status_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'order_status_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.inventory_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'inventory_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.product_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'product_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.cancellation_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'cancellation_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.refund_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'refund_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.shipment_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'shipment_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.return_sync_flow = data?.sync_flows?.find(f => f.flow_name === 'return_sync') || {
      status: 'NA',
      last_active: null,
    };
    this.userAccess = data?.user_access;
    this.profile = data?.profile ?? [];
  }
}

export default MiddlewareTable;
